<template>
  <custom-dialog append-to-body width="65%" :title="model.title" :visible="visible" v-on="$listeners">
    <div style="padding: 0 24px">
      <div>
        <search-input width="100%" :placeholder="$t('Common.com_department_name')" v-model="appKey"></search-input>
        <div style="padding: 24px 0; min-height: 537px">
          <custom-tree
            :expand-on-click-node="false"
            v-model="organData"
            :data="organTree"
            node-key="bizId"
            default-expand-all
            highlight-current
            :listener="appKey"
            :filterKeys="['bizName']"
            :props="{ label: 'bizName' }"
            @handleNode="handleNodeClick"
          >
            <template slot="label" slot-scope="scope">{{ scope.node.label }}</template>
          </custom-tree>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" :disabled="!organData" @click="bindOrganLocation">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import customTree from '@/components/customTree.vue';

export default {
  mixins: [dialogMixins],
  components: { customTree },
  props: {
    organ: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      appKey: '',
      organData: null,
      orgId: null,
      organTree: [],
    };
  },
  mounted() {
    this.getOrganTree();
  },
  methods: {
    // 选中部门
    handleNodeClick: function () {
      if (this.organData && this.organData.bizType === 1) {
        this.organData = null;
      }
    },
    // 获取部门树
    getOrganTree: function () {
      this.$getJSON(apis.DepartmentTree, { isCountDevice: 1 }).then((res) => {
        this.orgId = res.data.orgId;
        this.organTree = [res.data];
      });
    },
    // 关联项目、部门
    bindOrganLocation: function () {
      const selected = this.model.tableSelect || [];
      const params = selected.map(t => ({
        orgId: this.orgId,
        bizId: this.organData.departmentId,
        bizType: 2,
        toBizId: t.locationId,
        toBizType: 4,
      }));
      this.$postJSON(apis.organDeviceBindAutoAdd, params, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
  },
};
</script>

<style lang="scss"></style>
